import { getAPIErrorMessage } from 'api';
import * as debounce from 'debounce';
const sendTargetTemp = async (api, device_id, object_id, target_temp, request_time, dispatch, prev_target_temp) => {
    try {
        await api.send_z3k_command(device_id, {
            object_id,
            command_name: 'TargetTemperature',
            command_args: { value: target_temp },
        }, true, request_time);
    }
    catch (error) {
        const error_message = getAPIErrorMessage(error, 'Произошла ошибка');
        dispatch({
            type: 'SET_Z3K_TARGET_TEMP_FAIL',
            device_id,
            object_id,
            target_temp: prev_target_temp,
            request_time,
            error_message,
        });
        setTimeout(() => dispatch({
            type: 'SET_Z3K_TARGET_TEMP_RESET',
            device_id,
            object_id,
            target_temp: prev_target_temp,
            request_time,
        }), 0);
    }
};
const _debounced_cache = {};
const get_debounced_send_for = (device_id, object_id) => {
    const cache_key = `${device_id}:${object_id}`;
    const existing = _debounced_cache[cache_key];
    if (existing != null) {
        return existing;
    }
    return (_debounced_cache[cache_key] = debounce(sendTargetTemp, 500));
};
export const setZ3kTargetTemp = (device_id, object_id, target_temp, prev_target_temp) => (dispatch, getState, { api }) => {
    const request_time = new Date().getTime();
    const action = {
        type: 'SET_Z3K_TARGET_TEMP',
        device_id,
        object_id,
        target_temp,
        request_time,
    };
    dispatch(action);
    get_debounced_send_for(device_id, object_id)(api, device_id, object_id, target_temp, request_time, dispatch, prev_target_temp);
};
export const onZ3kTargetTempConfirmed = (device_id, object_id, request_time) => ({
    type: 'ON_Z3K_TARGET_TEMP_CONFIRMED',
    device_id,
    object_id,
    request_time,
});
